import { replace, startsWith } from 'lodash';
import { onlyNumbers } from './onlyNumbers';

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) return '';

  const cleaned = onlyNumbers(phoneNumber);

  let formattedPhoneNumber = '';

  if (startsWith(cleaned, '0800')) {
    formattedPhoneNumber = replace(cleaned, /^(\d{4})(\d{3})(\d{0,4}).*/, '$1 $2 $3');
  } else {
    formattedPhoneNumber = replace(cleaned, /^(\d\d)(\d{4,5})(\d{0,4}).*/, '($1) $2-$3');
  }
  return formattedPhoneNumber;
};
